import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    // Parallax effect for header
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const header = document.querySelector('header');
      if (header) {
        header.style.transform = `translateY(${scrolled * 0.5}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    document.querySelector(sectionId).scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <header>
        <h1>Sahyadri Garden</h1>
        <p>सह्याद्री गार्डन - Elevating Pune's Culinary Landscape with Timeless Indian Elegance</p>
      </header>
      
      <nav>
        <button onClick={() => scrollToSection('#home')}>Home</button>
        <button onClick={() => scrollToSection('#about')}>About</button>
        <button onClick={() => scrollToSection('#menu')}>Menu</button>
        <button onClick={() => scrollToSection('#gallery')}>Gallery</button>
        <button onClick={() => scrollToSection('#reviews')}>Reviews</button>
        <button onClick={() => scrollToSection('#contact')}>Contact</button>
      </nav>
      
      <section id="home">
        <div className="premium-card">
          <h2>Discover Timeless Elegance</h2> {/* Enhanced contrast below */}
          <p>Step into refined indulgence at Sahyadri Garden, where North Indian, Chinese, Biryani, Kebab, Mughlai, and Seafood masterpieces await in a serene garden setting. In South Pune's vibrant embrace, our haven delivers Marriott-inspired luxury—perfect for intimate dinners, joyous family gatherings, or bespoke events that linger in memory.</p>
          <div className="highlight">
            <strong>Rating: 3.5 ★ (377+ Reviews)</strong><br />
            <em>Affordable Elegance: ₹700 for Two | Open 11 AM – 11:30 PM Daily</em>
          </div>
        </div>
      </section>
      
      <section id="about">
        <div className="premium-card">
          <h2>Our Timeless Legacy</h2>
          <p>From our roots on Sinhagad Road, Sahyadri Garden embodies premium hospitality inspired by Pune's lush heritage. We fuse time-honored recipes with contemporary grace, sourcing pristine ingredients for dishes that enchant. Our verdant garden patios and opulent interiors set the stage for cherished moments. Tailored for weddings, celebrations, or quiet escapes—every visit unfolds like a legacy.</p>
          <p><strong>Cuisines:</strong> North Indian, Chinese, Biryani, Kebab, Mughlai, Seafood<br />
          <strong>Services:</strong> Dine-in, Takeaway, Catering, Private Events</p>
          <div className="highlight">
            <strong>Address:</strong> FR5H+4GF, Ambegaon, Mumbai-Pune Bypass Road, Sinhagad Road, Pune, Maharashtra 411041
          </div>
        </div>
      </section>
      
      <section id="menu">
        <h2>Culinary Masterpieces</h2>
        <p>Savor our handcrafted selection, where each dish whispers luxury—from saffron-kissed biryanis to silken kebabs, prepared by artisans devoted to perfection.</p>
        <div className="menu-grid">
          <div className="menu-item">
            <img 
              src="https://images.unsplash.com/photo-1701579231378-3726490a407b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
              alt="Velvety Butter Paneer Butter Masala" 
              loading="lazy" 
            />
            <h3>Butter Paneer Butter Masala</h3>
            <p>Velvety paneer in a sun-kissed tomato embrace, laced with fragrant spices. ₹250</p>
          </div>
          <div className="menu-item">
            <img 
              src="https://images.unsplash.com/photo-1666190091191-0cd0c5c8c5b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
              alt="Crispy Paneer Pakoda" 
              loading="lazy" 
            />
            <h3>Paneer Pakoda</h3>
            <p>Crispy havens of spiced paneer, golden and irresistible. ₹150</p>
          </div>
          <div className="menu-item">
            <img 
              src="https://images.unsplash.com/photo-1631515243349-e0cb75fb8d3a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
              alt="Saffron Chicken Biryani" 
              loading="lazy" 
            />
            <h3>Chicken Biryani</h3>
            <p>Saffron-infused basmati with tender chicken, a symphony of aromas. ₹300</p>
          </div>
          <div className="menu-item">
            <img 
              src="https://images.unsplash.com/photo-1555939594-58d7cb561ad1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
              alt="Grilled Seafood Kebab" 
              loading="lazy" 
            />
            <h3>Seafood Kebab</h3>
            <p>Grilled ocean jewels marinated in exotic whispers. ₹450</p>
          </div>
          <div className="menu-item">
            <img 
              src="https://images.unsplash.com/photo-1711153419402-336ee48f2138?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
              alt="Regal Mughlai Thali" 
              loading="lazy" 
            />
            <h3>Mughlai Thali</h3>
            <p>A regal procession of curries, breads, and rice. ₹350</p>
          </div>
          <div className="menu-item">
            <img 
              src="https://images.unsplash.com/photo-1679279726940-be5ce80c632c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
              alt="Wok-Tossed Hakka Noodles" 
              loading="lazy" 
            />
            <h3>Chinese Hakka Noodles</h3>
            <p>Wok-tossed strands with vibrant veggies and proteins. ₹200</p>
          </div>
        </div>
        <p style={{ textAlign: 'center', marginTop: '40px' }}><em>Full menu on-site. Vegetarian & Non-Vegetarian delights. Prices may vary.</em></p>
      </section>
      
      <section id="gallery">
        <h2>A Glimpse of Elegance</h2>
        <p>Through these vignettes, envision the warmth of our garden, the artistry of our plates, and the magic of your next gathering.</p>
        <div className="gallery">
          <img 
            src="https://images.unsplash.com/photo-1542367592-8849eb950fd8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
            alt="Serene Garden Ambiance" 
            loading="lazy" 
          />
          <img 
            src="https://images.unsplash.com/photo-1667388969250-1c7220bf3f37?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
            alt="Opulent Restaurant Interior" 
            loading="lazy" 
          />
          <img 
            src="https://images.unsplash.com/photo-1728910156510-77488f19b152?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
            alt="Artful Appetizer Platter" 
            loading="lazy" 
          />
          <img 
            src="https://images.unsplash.com/photo-1589302168068-964664d93dc0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
            alt="Aromatic Biryani Closeup" 
            loading="lazy" 
          />
          <img 
            src="https://plus.unsplash.com/premium_photo-1661433201283-fcb240e88ad4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
            alt="Festive Event Setup" 
            loading="lazy" 
          />
          <img 
            src="https://images.unsplash.com/photo-1643856557143-09189e523fd6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
            alt="Inviting Outdoor Seating" 
            loading="lazy" 
          />
        </div>
      </section>
      
      <section id="reviews">
        <h2>Voices of Joy</h2>
        <p>Cherished tales from our guests, drawn from Google—celebrating flavors, warmth, and those special nights.</p>
        <div className="premium-card">
          <div className="review">
            <div className="stars">★★★★★</div>
            <strong>Rajshri Jadhav (2023):</strong> "Service is exceptional, staff so attentive. Yummy food—truly a delight!"
          </div>
          <div className="review">
            <div className="stars">★★★★☆</div>
            <strong>Abhijeet Potphode (2024):</strong> "Nice ambiance outside the city, food tastes really good. Can carry favorites too."
          </div>
          <div className="review">
            <div className="stars">★★★★★</div>
            <strong>Farheen Shaikh (2023):</strong> "Awesome garden, tasty foods! Our favorite spot for monthly dinners 😋."
          </div>
          <div className="review">
            <div className="stars">★★★★☆</div>
            <strong>Amol Gaikwad (2024):</strong> "Food quality is awesome and in budget. Service: Dine-in perfection."
          </div>
          <div className="review">
            <div className="stars">★★★★★</div>
            <strong>Sagar Shinde (2023):</strong> "Very good hotel, taste also spot-on. Service: Dine-in delight."
          </div>
          <div className="review">
            <div className="stars">★★★★☆</div>
            <strong>Akhilesh Mahajan (2024):</strong> "Food was really good. Service and dine-in ambiance: 5/5."
          </div>
          <div className="review">
            <div className="stars">★★★★☆</div>
            <strong>Vaishnavi Kamble (2024):</strong> "Very affordable. Perfect for cozy dinners."
          </div>
          <div className="review">
            <div className="stars">★★★☆☆</div>
            <strong>Vikram Kerure (2023):</strong> "Ambiance lovely, biryani shines—though chef tweaks keep it exciting."
          </div>
          <div className="review">
            <div className="stars">★★★★☆</div>
            <strong>Shreyas Singh (2022):</strong> "Chicken Malvani is great—do visit for that alone!"
          </div>
          <div className="review">
            <div className="stars">★★★☆☆</div>
            <strong>Abhishek Savilake (2023):</strong> "Nice chill spot with own drinks. Taste hits the mark for evenings."
          </div>
        </div>
        <p style={{ textAlign: 'center' }}><em>Join 377+ cherished guests. Share your story on Google!</em></p>
      </section>
      
      <section id="contact">
        <h2>Reserve Your Moment</h2>
        <p>Allow us to orchestrate your perfect escape. Inquire today.</p>
        <div className="highlight">
          <strong>Location:</strong> FR5H+4GF, Ambegaon, Sinhagad Road, Pune<br />
          <strong>Phone:</strong> +91-XXXX-XXXXXX (Update via Google My Business)<br />
          <strong>Email:</strong> reservations@sahyadrigarden.com<br />
          <strong>Hours:</strong> 11 AM – 11:30 PM Daily
        </div>
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3813.XXXX!2d73.XXXX!3d18.XXXX!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM4KwNTAnMjAuNiJOIDczwrAwMycyNS4xIkU!5e0!3m2!1sen!2sin!4v169XXXXXXX!5m2!1sen!2sin" 
          title="Sahyadri Garden Location on Google Maps"
          allowFullScreen="" 
          loading="lazy"
        />
      </section>
      
      <footer>
        <p>&copy; 2025 Sahyadri Garden. All Rights Reserved. | Timeless Dining, Eternal Memories | Follow for Exclusive Invites</p>
      </footer>
    </>
  );
}

export default App;